interface IDynamicTableDataLayer {
  productsCount: number
  brands?: string
}

export const parseDynamicTableData = (): IDynamicTableDataLayer => {
  const dtSections = document.querySelectorAll('section[data-dt-product-count]')
  const brandSet = new Set()
  let productsCount = 0
  let brands

  if (dtSections.length > 0) {
    dtSections.forEach((product: HTMLElement) => {
      const { dtProductBrands, dtProductCount } = product.dataset
      productsCount += parseInt(dtProductCount, 10)
      if (dtProductBrands) {
        dtProductBrands.split(',').forEach((brand) => brandSet.add(brand))
      }
    })

    if (brandSet.size > 0) {
      brands = Array.from(brandSet).join('|')
    }
  }
  if (productsCount > 0) {
    return brands ? { productsCount, brands } : { productsCount }
  }
}
